<app-prime-loader *ngIf="signingIn$ | async"></app-prime-loader>
<div class="login-container" *ngIf="!(signingIn$ | async)">
  <div class="login">
    <div class="sbi-logo">
      <img src="assets/images/sbi-logo.svg" alt="SBI" />
    </div>
    <div class="title">Iniciar sesión</div>
    <div class="subtitle">
      Para acceder al portal administrador, inicia sesión con tu cuenta de
      Microsoft.
    </div>
    <div class="login-action">
      <button
        class="button"
        [class.loading]="signingIn$ | async"
        [disabled]="signingIn$ | async"
        (click)="onUserLogin()"
      >
        <img src="assets/images/logo-microsoft.png" alt="Microsoft" />Iniciar
        sesión con Microsoft
      </button>
    </div>
    <div class="login-error" *ngIf="loginFailed$ | async">
      <span
        >Ocurrió un error en el inicio de sesión. Verifica los datos e inténtalo
        de nuevo.</span
      >
    </div>
  </div>
</div>
